import React, {Component,PropTypes} from 'react'
import firebase from '../../config/database'


class Secciones extends Component {

  constructor(props) {
    super(props);
    this.state = {
      values:props.value.split(","),
      opciones:[],
      idclinica:"",
    };
    this.handleChange=this.handleChange.bind(this);
    this.renderAnOption=this.renderAnOption.bind(this);
  }

  //Change events on all inputs
  handleChange(event) {
    //Find if we have this elemet already selected
    var selectedItems=this.state.values;
    var indexOfItem=selectedItems.indexOf(event.target.value);
    if(indexOfItem==-1){
      //It doesn't exist, add it
      selectedItems.push(event.target.value);
    }else{
      //Remove it, make it unselected
       selectedItems.splice(indexOfItem, 1);
    }
    this.setState({value: selectedItems});
    console.log(selectedItems.toString());
    this.props.updateAction(this.props.theKey,selectedItems.toString());
  }

getidclinica(){

       

         // EXTRAER LA ID CLINICA PARA PASARLO COMO TOPIC 

             

             

        }


  findFirestoreRelatedData(){

    console.log("Coger Opciones");
     
     var db = firebase.app.firestore();
     //COLLECTIONS - GET DOCUMENTS 
     var optionsFromFirebse=[];
     var _this=this;
     var user = firebase.app.auth().currentUser;
     var refidclinica;
     var database = firebase.app.firestore();


       // GET ID CLINICA

      

              database.collection("usuaris").where("email" , "==" ,user.email).get().then(function(Snapshot) {

                 Snapshot.forEach(function(docupdate) {

                     var usuariupdate = docupdate.data();

                     refidclinica = db.collection("cliniques").doc(usuariupdate.clinica);
                     
     
// GET COLLECTIONS


                       db.collection("seccions").where("clinica", "==" , refidclinica).get().then(function(querySnapshot) {
                         querySnapshot.forEach(function(doc) {
                             var currentDocument=doc.data();
                             currentDocument.uidOfFirebase=doc.id;
        

                             var newOption={
                                value:doc.id,
                                name:currentDocument.title,
                            }
                              console.log(newOption);
                              optionsFromFirebse.push(newOption);
 
                          });
                      _this.setState({opciones:optionsFromFirebse})
                        });
 
                      

                });

              });  

 }



  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  

  renderAnOption(value){
    return (
      <li>
      
          <input type="checkbox" name={this.props.theKey} value={value.value} checked={this.state.values.indexOf(value.value)>-1}  onChange={this.handleChange} />
          <span className="checkbox-material"><span className="check"></span></span> {this.capitalizeFirstLetter(value.name)}
        
      </li>
    )
  }

  componentDidMount(){
    if(this.props.isFirestore){
      
      this.findFirestoreRelatedData();
    }else{
     
      this.findFirebaseRelatedData();
    }
  }



  render() {
    return (
 
    <div className="dropdown">
    <button className="btn btn-primary btn-round dropdown-toggle" type="button" data-toggle="dropdown">Secciones Seleccionadas
    <span className="caret"></span></button>
    
 
    <ul className="dropdown-menu">
    <div className="form-group label-floating is-empty checkbox-radios">
              {this.state.opciones.map((val)=>{
                return this.renderAnOption(val);
              })}
       </div> 
    </ul>
  
    
  </div>

    )
  }
}
export default Secciones;

Secciones.propTypes = {
    updateAction:PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    theKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/fields/Secciones.js